module.exports = __webpack_public_path__ + "static/img/3d.4feae2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3d.jpg
// module id = M+m2
// module chunks = 0